// Libraries
var React = require('react');

class GenericImage extends React.Component { 
	constructor(props) {
		super(props);
	}

	render() {
		const altText = this.props.alt ? this.props.alt : this.props.image.altText;
		return (
			<picture>
				<source media="(min-width: 1600px)" srcSet={this.props.image.extraLargeUrl} />
				<source media="(min-width: 1400px)" srcSet={this.props.image.largeUrl} />
				<source media="(min-width: 1024px)" srcSet={this.props.image.mediumUrl} />
				<img src={this.props.image.smallUrl} alt={altText} loading={this.props.loading} className={this.props.class} />
			</picture>
		);
	}
};

module.exports = GenericImage;


// WEBPACK FOOTER //
// ./src/components/GenericImage/GenericImage.js